import { render, staticRenderFns } from "./subdealer_next.vue?vue&type=template&id=fd94838e&scoped=true&"
import script from "./subdealer_next.vue?vue&type=script&lang=js&"
export * from "./subdealer_next.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd94838e",
  null
  
)

export default component.exports